// @flow
import styled from "styled-components";
import {styles} from "../../config";
import {Col4} from "../Columns";

export const topHeaderBarHeight = `46px`;


export const TopBarContainer = styled.div`
    position: fixed;
    width: 100%;
    min-height: ${topHeaderBarHeight};
    height: ${topHeaderBarHeight};
    z-index: 102;
    box-shadow: 0 2px 9px 0 #0000001e;
    background-color: ${styles.primaryColor};
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
`;

export const TopBarElement = styled.div`
    ${Col4};
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/Components/TopBar/TopBarStyle.js